import { render, staticRenderFns } from "./AnswerCard.vue?vue&type=template&id=7af72c88&scoped=true&"
import script from "./AnswerCard.vue?vue&type=script&lang=js&"
export * from "./AnswerCard.vue?vue&type=script&lang=js&"
import style0 from "./AnswerCard.vue?vue&type=style&index=0&id=7af72c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af72c88",
  null
  
)

component.options.__file = "AnswerCard.vue"
export default component.exports